module.exports = __webpack_public_path__ + "static/Sam-e222f690f498b5b6a536f72b5b5e5531.png";